@if (loading && messages.length === 0) {
  <div class="st-loading animate-pulse" role="status" aria-label="Cargando mensajes">
    <span class="h-3 w-32 rounded bg-gray-200 dark:bg-gray-800"></span>
    <span class="h-12 w-full rounded-lg bg-gray-100 dark:bg-gray-800/70"></span>
  </div>
} @else if (messages.length === 0) {
  <p class="st-empty">{{ emptyText }}</p>
} @else {
  <ol class="st-list" [class.opacity-60]="loading">
    @for (message of messages; track message.supportTicketMessageId) {
      <li class="st-msg" [attr.data-role]="message.authorRole" [class.st-msg--own]="isOwn(message)">
        <p class="st-msg__head">
          <span class="st-msg__author">{{ authorLabel(message) }}</span>
          @if (viewer === 'support' && message.authorRole === 'support') {
            <span class="st-msg__role">Soporte</span>
          }
          <time class="st-msg__time" [attr.datetime]="message.createdAt">{{ message.createdAt | date: "d MMM, h:mm a" }}</time>
        </p>
        <p class="st-msg__body">{{ message.body }}</p>
      </li>
    }
  </ol>
}
